export const getLoginUrl = () => '/login';

export const getRegistrationUrl = () => '/registration';
